import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
import dayjs from "dayjs";
import { Slider } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHandPaper } from '@fortawesome/free-solid-svg-icons/faHandPaper';
import { faPlay } from '@fortawesome/free-solid-svg-icons/faPlay';
import { faStop } from '@fortawesome/free-solid-svg-icons/faStop';
import { useInterval } from "usehooks-ts";
import { useApiIsLoaded } from '@vis.gl/react-google-maps';
import { AdvancedMarker } from '../../components/googleMap';
import { Polyline } from "../../components/googleMap";
import DriverLocationHistoryInfoWindow from "./DriverLocationHistoryInfoWindow";
import VehicleMarker from './markers/VehicleMarker';
const TIME_FORMAT = "hh:mma";
const DriverLocationSlider = ({ driverIdleAlertMinutes, driverLocationHistory }) => {
    const mapsApiLoaded = useApiIsLoaded();
    const [sliderPos, setSliderPos] = useState(0);
    const [autoplay, setAutoplay] = useState(false);
    const [marks, setMarks] = useState();
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [polylinePath, setPolylinePath] = useState([]);
    const [infoWindowVisible, setInfoWindowVisible] = useState(false);
    const markerRef = useRef(null);
    useEffect(() => {
        updatePolylineAndSliderMarks();
        onChange(0);
    }, [driverLocationHistory]);
    useInterval(() => {
        moveToNextLocation();
    }, autoplay ? 30000 : null);
    const updatePolylineAndSliderMarks = () => {
        if (!driverLocationHistory || driverLocationHistory.length === 0) {
            return;
        }
        const polylinePath = driverLocationHistory.map(item => {
            return {
                lat: item.latitude,
                lng: item.longitude
            };
        });
        const lastIdx = driverLocationHistory.length - 1;
        const marks = {
            0: dayjs(driverLocationHistory[0].recordedAt).format(TIME_FORMAT),
            [lastIdx]: dayjs(driverLocationHistory[lastIdx].recordedAt).format(TIME_FORMAT)
        };
        // Make sure we have at least a few history records before adding idle marks otherwise it just gets very busy
        const driverIdleAlertSeconds = (driverIdleAlertMinutes * 60);
        if (driverLocationHistory.length > 10) {
            for (let idx = 0; idx < driverLocationHistory.length - 1; idx++) {
                if (driverLocationHistory[idx].idleSeconds > driverIdleAlertSeconds && driverLocationHistory[idx + 1].idleSeconds <= 0) {
                    marks[idx] = _jsx(FontAwesomeIcon, { icon: faHandPaper });
                }
            }
        }
        setPolylinePath(polylinePath);
        setMarks(marks);
    };
    const onChange = (sliderPos) => {
        if (driverLocationHistory && sliderPos < driverLocationHistory.length) {
            setSelectedLocation(driverLocationHistory[sliderPos]);
            setSliderPos(sliderPos);
        }
    };
    const tooltipFormatter = (sliderPos) => {
        if (driverLocationHistory && sliderPos && sliderPos < driverLocationHistory.length) {
            const driverLocation = driverLocationHistory[sliderPos];
            return dayjs(driverLocation.recordedAt).format(TIME_FORMAT);
        }
        return null;
    };
    const buildVehicleIcon = (location) => {
        const driverBearing = Math.round(location.bearingDegrees || 0);
        return 'data:image/svg+xml;charset=utf-8,' + VehicleMarker.svg(driverBearing, 52, 48);
    };
    const toggleAutoplay = () => {
        setAutoplay(!autoplay);
    };
    const moveToNextLocation = () => {
        let nextLocationIdx = sliderPos + 1;
        if (driverLocationHistory && nextLocationIdx >= driverLocationHistory.length) {
            nextLocationIdx = 0;
        }
        onChange(nextLocationIdx);
    };
    const hideInfoWindow = () => {
        setInfoWindowVisible(false);
    };
    const showInfoWindow = () => {
        setInfoWindowVisible(true);
    };
    if (!driverLocationHistory || !driverLocationHistory.length || !mapsApiLoaded) {
        return null;
    }
    return (_jsxs("div", { className: "map-slider", children: [_jsx("button", { className: "btn pull-right", onClick: toggleAutoplay, children: autoplay ? _jsx(FontAwesomeIcon, { icon: faStop }) : _jsx(FontAwesomeIcon, { icon: faPlay }) }), _jsx(Slider, { style: { marginRight: "35px" }, min: 0, max: driverLocationHistory.length - 1, onChange: onChange, value: sliderPos, tooltip: { formatter: tooltipFormatter }, marks: marks }), polylinePath &&
                _jsx(Polyline, { path: polylinePath }, "location-history"), selectedLocation &&
                _jsx(AdvancedMarker, { ref: markerRef, onClick: showInfoWindow, imageUri: buildVehicleIcon(selectedLocation), anchorCenter: true, position: {
                        lat: selectedLocation.latitude,
                        lng: selectedLocation.longitude
                    }, zIndex: 5 }, "DriverLocationHistoryRecordedLocation"), selectedLocation &&
                _jsx(DriverLocationHistoryInfoWindow, { windowKey: "DriverLocationHistoryInfoWindow", markerRef: markerRef, visible: infoWindowVisible, driverLocation: selectedLocation, onClose: hideInfoWindow }, "DriverLocationHistoryInfoWindow")] }));
};
export default DriverLocationSlider;
